import { render } from "./Progress.vue?vue&type=template&id=4b4672be&scoped=true"
import script from "./Progress.vue?vue&type=script&lang=js"
export * from "./Progress.vue?vue&type=script&lang=js"

import "./Progress.vue?vue&type=style&index=0&id=4b4672be&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4b4672be"

export default script